import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'payors',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'apply-payment-plan' })
  }
}
